import { gql } from '@apollo/client';

export const QUERY_TATTOOS_AND_PIERCINGS = gql`
  query appearances {
    tattoos {
      id
      name
    }
    piercings {
      id
      name
    }
  }
`;
